import { render, staticRenderFns } from "./AssetTypeCodes.vue?vue&type=template&id=49f36136"
import script from "./AssetTypeCodes.vue?vue&type=script&lang=js"
export * from "./AssetTypeCodes.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeCodes.vue?vue&type=style&index=0&id=49f36136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports